var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"picker"},[_c('picker')],1),_c('contrast',{staticStyle:{"margin-top":"40px"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }